import { contextFactory } from '@frontend/design-system';
import { UseFormsSubmissionDetailsV2ProviderResults } from '../hooks';

export const [FormsSubmissionDetailsV2Context, useFormsSubmissionsDetailsV2Context] =
  contextFactory<UseFormsSubmissionDetailsV2ProviderResults>();
